var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectricityIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22624",
    "data-name": "Group 22624",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.103,
    height: 28.844,
    viewBox: "0 0 26.103 28.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6309",
    "data-name": "Rectangle 6309",
    width: 26.103,
    height: 28.844,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22623",
    "data-name": "Group 22623",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36031",
    "data-name": "Path 36031",
    d: "M8.121.441A10.952,10.952,0,0,0,6.534,0H5.184A11.876,11.876,0,0,0,3.376.568,5.664,5.664,0,0,0,.136,4.6c-.048.2-.091.4-.136.6V6.508c.121.44.213.89.367,1.317A5.844,5.844,0,0,0,7.9,11.346a5.778,5.778,0,0,0,3.716-6.779A5.587,5.587,0,0,0,8.121.441M5.9,10.842a5.014,5.014,0,1,1,5.025-5.017A5.023,5.023,0,0,1,5.9,10.842",
    transform: "translate(0 0.001)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36032",
    "data-name": "Path 36032",
    d: "M68.076,82.6q-1.888,1.815-3.775,3.631-1.7,1.637-3.386,3.283a2.778,2.778,0,0,0-.2.247H60.12q-1.253-1.27-2.505-2.539c-.292-.3-.572-.6-.886-.874-.258-.221-.293-.408-.036-.638a1.98,1.98,0,0,0,.169-.2c.1.085.2.16.292.247q1.25,1.234,2.5,2.471c.493.487.849.47,1.344-.006q3.156-3.037,6.321-6.064c.161-.155.278-.181.429,0a4.1,4.1,0,0,0,.33.317Z",
    transform: "translate(-41.973 -60.919)",
    fill: "#19cbcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36033",
    "data-name": "Path 36033",
    d: "M8.222,48.061c.392.184.732.325,1.049.507.077.044.1.226.1.345.007,1.2,0,2.407,0,3.611v6.432a1.893,1.893,0,0,0,.259-.076c.507-.247.629-.229,1.043.161l1.65,1.549,1.449-1.308c.113-.1.224-.209.341-.308A.615.615,0,0,1,15.1,59c.56.521,1.116,1.046,1.715,1.608l1.936-1.835c.183.4.347.723.48,1.062a.324.324,0,0,1-.089.282c-.428.377-.873.735-1.306,1.108-.182.157-.345.336-.521.5-.364.342-.6.351-.966.015-.507-.466-1.011-.937-1.5-1.419-.172-.169-.284-.206-.481-.02-.5.473-1.024.922-1.542,1.376a.623.623,0,0,1-.98,0q-.808-.745-1.6-1.51a.32.32,0,0,0-.481-.05c-.212.152-.452.264-.678.4a.573.573,0,0,1-.854-.45,2.067,2.067,0,0,1-.012-.262q0-5.712,0-11.425v-.308",
    transform: "translate(-6.106 -35.693)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36034",
    "data-name": "Path 36034",
    d: "M59.866,72.367c-.192-.237-.367-.492-.58-.708q-1.511-1.53-3.043-3.039c-.186-.183-.218-.3-.013-.5Q59.9,64.6,63.552,61.063a1.926,1.926,0,0,1,.166-.127c.073.061.143.111.2.171,1.18,1.173,2.355,2.35,3.54,3.518.171.169.185.277.006.449q-3.675,3.539-7.341,7.087a1.554,1.554,0,0,1-.154.116l-.108.09m3.2-9.564a1.079,1.079,0,0,0-.111.077q-2.448,2.331-4.89,4.669a.374.374,0,0,0-.052.328A1.036,1.036,0,0,1,58,68.73a.371.371,0,0,0,.064.33q.6.63,1.24,1.221a.373.373,0,0,0,.323.035.864.864,0,0,1,.819,0c.183.116.286.064.42-.064,1.58-1.513,3.167-3.02,4.742-4.538a.394.394,0,0,0,.075-.355.938.938,0,0,1,.009-.846.37.37,0,0,0-.053-.332c-.405-.43-.826-.846-1.254-1.254a.291.291,0,0,0-.269-.045.9.9,0,0,1-1.05-.078",
    transform: "translate(-41.654 -45.255)",
    fill: "#19cbcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36035",
    "data-name": "Path 36035",
    d: "M61.626,25.249c-.375-.278-.717-.509-1.026-.778-.082-.071-.088-.258-.088-.392q-.007-3.908,0-7.815c0-.3-.021-.593.006-.886.028-.314-.1-.386-.393-.385C57.393,15,54.665,15,51.937,15c-.581,0-.583,0-.741-.553-.047-.165-.078-.336-.127-.549.145-.015.257-.037.37-.037q4.733,0,9.466,0c.565,0,.741.18.742.749q0,5.156,0,10.311c0,.1-.013.21-.02.33",
    transform: "translate(-37.927 -10.292)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36036",
    "data-name": "Path 36036",
    d: "M24.9,51.488H37.031c.45,0,.456,0,.449.45-.011.746.139.685-.674.685q-5.735,0-11.47,0c-.435,0-.435,0-.436-.425,0-.227,0-.454,0-.712",
    transform: "translate(-18.492 -38.238)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36037",
    "data-name": "Path 36037",
    d: "M24.905,67.722c0-.346-.01-.651.008-.953,0-.063.1-.139.176-.173a.582.582,0,0,1,.227-.007H36.6l.049.087c-.215.215-.449.417-.641.651a1.113,1.113,0,0,1-.965.406c-3.229-.018-6.458-.01-9.687-.01Z",
    transform: "translate(-18.494 -49.447)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36038",
    "data-name": "Path 36038",
    d: "M55.135,37.669c-.886,0-1.772-.007-2.657,0-.239,0-.323-.064-.325-.313,0-.818-.013-.818.8-.818h4.79c.438,0,.438,0,.438.426,0,.7,0,.7-.686.7H55.135",
    transform: "translate(-38.732 -27.139)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36039",
    "data-name": "Path 36039",
    d: "M16.16,10.255a2.269,2.269,0,0,1,2.06,3.4,7.78,7.78,0,0,1-.8,1.156.767.767,0,0,1-.46.2c-.507.077-1.018.137-1.529.174a.5.5,0,0,1-.394-.152,13.821,13.821,0,0,1-.948-1.631,2.242,2.242,0,0,1,2.068-3.152m.437.816-.11-.037a2.28,2.28,0,0,0-.193.238c-.3.483-.59.967-.878,1.455-.159.268-.118.352.2.349.244,0,.312.089.266.313a6.184,6.184,0,0,0-.106.645.788.788,0,0,0,.068.26c.074-.05.175-.084.218-.153.325-.516.636-1.041.957-1.561.133-.215.053-.315-.17-.309-.259.007-.272-.126-.258-.332.02-.288.005-.579.005-.868",
    transform: "translate(-10.316 -7.616)",
    fill: "#19cbcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36040",
    "data-name": "Path 36040",
    d: "M21.051,29.772c.11.353.012.495-.292.521-.455.039-.907.108-1.362.139a.35.35,0,0,1-.275-.163c-.08-.174.047-.25.212-.272l1.717-.225",
    transform: "translate(-14.183 -22.11)",
    fill: "#19cbcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36041",
    "data-name": "Path 36041",
    d: "M21.95,33.191a.825.825,0,0,1-1.375.184l1.375-.184",
    transform: "translate(-15.28 -24.65)",
    fill: "#19cbcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36042",
    "data-name": "Path 36042",
    d: "M74.255,81.013a1.3,1.3,0,0,1-1.269-1.28,1.278,1.278,0,0,1,2.555.019,1.286,1.286,0,0,1-1.285,1.261",
    transform: "translate(-54.203 -58.302)",
    fill: "#19cbcd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricityIcon);
export default __webpack_public_path__ + "static/media/ElectricityIcon.57c90734855151e0e2ae2e6175a9ce8a.svg";
export { ForwardRef as ReactComponent };